module.exports = __webpack_public_path__ + "static/media/KatherineMoss3.d5920d15.svg";